import router from '@/router'
const DEFAULT_TRADE_SYSTEM_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8082/#/login'
  : 'http://pc.heymetaplayer.com/#/login'

/**
 * 获取 PC 交易系统地址，并按需携带当前交易账号 ID。
 * 交易端使用 hash 路由，因此参数需要拼接在 #/login 后面。
 */
export function getTradeSystemUrl (tradeAccountId) {
  const baseUrl = process.env.VUE_APP_TRADE_SYSTEM_URL || DEFAULT_TRADE_SYSTEM_URL
  const normalizedId = tradeAccountId === undefined || tradeAccountId === null
    ? ''
    : String(tradeAccountId).trim()

  const separator = baseUrl.includes('?') ? '&' : '?'
  const params = []
  if (normalizedId) params.push('trade_account_id=' + encodeURIComponent(normalizedId))
  if (typeof window !== 'undefined') {
    const transferUrl = new URL(router.resolve({ name: 'userTransfer' }).href, window.location.href).href
    params.push('user_center_transfer_url=' + encodeURIComponent(transferUrl))
  }
  return params.length ? `${baseUrl}${separator}${params.join('&')}` : baseUrl
}

/**
 * 在新的浏览器标签页中进入 PC 交易系统。
 */
export function enterTradeSystem (tradeAccountId) {
  if (typeof window === 'undefined') return

  const targetUrl = getTradeSystemUrl(tradeAccountId)
  const tradeWindow = window.open(targetUrl, '_blank', 'noopener,noreferrer')

  if (tradeWindow) {
    tradeWindow.opener = null
  }
}
